import { Directive, Input, OnInit } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';
import { ObjectUtils } from 'src/app/shared/utils/object.utils';

@Directive({
  selector: '[refreshOnChange]'
})
export class RefreshOnChangeDirective implements OnInit {

  @Input()
  refreshOnChange: AbstractControl | AbstractControl[];

  constructor(private control: NgControl) { }

  ngOnInit() {
    try {
      this.validate();
      this.setUpRefresh();
    } catch (error) {
      console.warn(error);
    }
  }

  private validate(): void {
    if (!this.control || !this.control.control) {
      throw Error('No master control found');
    }
    if (!this.refreshOnChange) {
      throw Error('No slave control found');
    }
  }

  private setUpRefresh(): void {
    this.control.control.valueChanges
      .subscribe(() => this.refreshSlaves());
  }

  private refreshSlaves(): void {
    if (ObjectUtils.isArray(this.refreshOnChange)) {
      this.refreshOnChange.forEach(slave => slave.updateValueAndValidity());
    } else if (this.refreshOnChange instanceof AbstractControl) {
      this.refreshOnChange.updateValueAndValidity();
    }
  }
}
